export default __webpack_public_path__ + "static/media/image.media-horizon.b19ea2a3.png";